import { Gem, UserCheck, MapPin } from "lucide-react";

const standards = [
  {
    icon: Gem,
    title: "Matched, Never Assigned.",
    description:
      "Every relationship begins with a thoughtful match. We take the time to understand your loved one's personality, interests, and daily rhythms — then pair them with a companion suited to fit, not just a schedule. There are no intake forms that feel like job applications. There is only a conversation.",
  },
  {
    icon: UserCheck,
    title: "One Point of Contact. Always.",
    description:
      "You will have a dedicated care concierge — one person who knows your family, anticipates your needs, and is reachable when it matters. Not a call center. Not a rotating roster. One trusted advocate.",
  },
  {
    icon: MapPin,
    title: "The Best of Nashville, At Your Door.",
    description:
      "From private transportation to errands, event accompaniment to post-travel recovery support — whatever matters to your family, handled with the same care and attention to detail.",
  },
];

const DifferentByDesign = () => (
  <section className="py-24 md:py-32 bg-card">
    <div className="container">
      <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-warm-ink text-center mb-4 font-medium">Our Standards</p>
      <h2 className="text-3xl md:text-5xl font-heading font-semibold text-center mb-6">The Kinship Standard for Nashville Senior Care</h2>
      <div className="w-16 h-px bg-warm mx-auto mb-16" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {standards.map((s, i) => (
          <div key={i} className="p-8 md:p-10 rounded-lg bg-background border border-border">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-warm/15 mb-6">
              <s.icon className="h-5 w-5 text-warm" />
            </div>
            <h3 className="font-heading font-semibold text-xl mb-3 leading-snug">{s.title}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">{s.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default DifferentByDesign;
